import './ssamnzoo/style';
import FormStructure from './ssamnzoo/form_structure';

export default FormStructure;